import { UserSelectWithRole } from './User';
export var OrganizationInclude = {
    logo: true,
    industry: true,
    sustainabilityReports: { where: { deleted: false } },
    stories: {
        where: { deleted: false },
        include: {
            banner: true,
            actionArea: true,
        },
    },
    certifications: {
        where: { deleted: false },
        include: {
            logo: true,
        },
    },
    pricing: {
        include: {
            features: true,
            limits: {
                include: {
                    feature: true,
                },
            },
        },
    },
    associatedSuppliers: true,
};
export var OrganizationExportInclude = {
    actions: true,
    apiKeys: true,
    locations: { where: { deleted: false } },
    products: { where: { deleted: false } },
    users: {
        where: { deleted: false },
        select: UserSelectWithRole,
    },
    logEntries: true,
    subcategories: true,
    stories: { where: { deleted: false } },
    logs: true,
    certifications: { where: { deleted: false } },
    sustainabilityReports: { where: { deleted: false } },
    industry: true,
    logo: true,
    customers: true,
    factors: true,
    targets: { where: { deleted: false } },
};
//# sourceMappingURL=Organization.js.map